/*global translate*/
import { connect } from 'react-redux'
import * as Jsx from './index.jsx'

const RxComponent = global.rootRequire('components/shares/rxComponent').default
const { rxaget, changeTheme, changeColorSVG } = global.rootRequire('classes/ulti')
const { apiGetUserStatus } = global.rootRequire('classes/api')
const { netaCallHistoryUpdate, changeStatusTabmore, clickCall, updateRecentContactGroups, clickGroupCall, rxnavToggle, chooseGroupAction } = global.rootRequire('redux')
const { checkBlock, updateUsersOnline, getNumMemberOnl } = global.rootRequire('classes/chat')
const themeData = global.rootRequire('classes/themeData.json')
const { rxgetLocal } = global.rootRequire('classes/request')
const chatDB = global.rootRequire('classes/indexedDB').default

class HeaderComponent_ extends RxComponent {
  constructor(props, context) {
    super(props, context, Jsx)
    this.state = {
      tabmore: rxaget(this.props, 'tabmore.data'),
      group_id: rxaget(this.props, 'rxgroup.groupid', ''),
      group: rxaget(this.props, 'rxgroup.group', {}),

      listCallLog: [],
      flagCalling: 0,
      objsCalling: {},
      objsGroupTmp: {},
      showChatCall: false,
      callType: 0,
      flagTurnOffSoundCall: false,
      typeCall: 1,
      usersStatus: {},
      countMemberOnl: 0,
      isBlocked: false,
      isShowBtnGroupCall: true,
      objGroupCallInfo: {},
      partnerUSer: { profile_url: '', full_name: '' }
    }
    this.userid = rxaget(this.props, 'netaauth.user.id', '')
    this.token = rxaget(this.props, 'netaauth.user.token', '')
    this.users = rxaget(this.props, 'user.users', {}) || {}
    //this.config = {
    //  iceServers: [{
    //    urls: ['turn:turn.hura.asia:3478'],
    //    username: 'developer',
    //    credential: 'password'
    //  }, {
    //    urls: ['stun:turn.hura.asia:3478'],
    //    username: 'developer',
    //    credential: 'password'
    //  }]
    //}
    this.config = {
			iceServers: [
				{ urls: "stun:stun.l.google.com:19302" },
				{ urls: "stun:stun.l.google.com:5349" },
				{ urls: "stun:stun1.l.google.com:3478" },
				{ urls: "stun:stun1.l.google.com:5349" },
				{ urls: "stun:stun2.l.google.com:19302" },
				{ urls: "stun:stun2.l.google.com:5349" },
				{ urls: "stun:stun3.l.google.com:3478" },
				{ urls: "stun:stun3.l.google.com:5349" },
				{ urls: "stun:stun4.l.google.com:19302" },
				{ urls: "stun:stun4.l.google.com:5349" }
			],
      //iceServers: [{
      //  urls: ['turn:turn.bobacu.io:3478'],
      //  username: 'turnuser',
      //  credential: 'turn456'
      //}],
      //iceTransportPolicy: "relay"
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!Object.is(this.users, nextProps.user.users)) {
      this.users = nextProps.user.users
    }
    let checkChangeTabmore = false
    let tabmore = (nextProps.tabmore === true || nextProps.tabmore.data === true) ? true : false
    if (tabmore !== this.state.tabmore) {
      checkChangeTabmore = true
      this.setState({
        tabmore: tabmore
      })
    } else {
      checkChangeTabmore = false
    }
    if (nextProps.rxgroup && nextProps.rxgroup.group) {
      let isBlocked = checkBlock(nextProps.rxgroup.group)
      if (isBlocked !== this.state.isBlocked) {
        this.setState({ isBlocked })
      }
      let group = { ...this.state.group }
      let newGroup = rxaget(nextProps.rxgroup, 'group', {})
      let flagCheckUpdateStatus = this.checkUpdateUserStatus(group, newGroup)

      if (
        flagCheckUpdateStatus ||
        (rxaget(nextProps.rxgroup, 'group.group_fullname', '') !== rxaget(this.state.group, 'group_fullname', '')) ||
        (rxaget(nextProps.rxgroup, 'group.avatar_url', '') !== rxaget(this.state.group, 'avatar_url', '')) ||
        (rxaget(nextProps.rxgroup, 'group.occupants_uins', []).length !== rxaget(this.state.group, 'occupants_uins', []).length)
      ) {
        if (!flagCheckUpdateStatus) {
          newGroup.userStatus = rxaget(group, 'userStatus', {})

        }
        this.setState({
          group: newGroup
        })
      }
    }
    // if (nextProps.usersStatus) {
    //   try {
    //     let groupTemp = nextProps.rxgroup.group || this.state.group
    //     const { isChange, usersStatus, countMemberOnl } =
    //       updateUsersOnline(groupTemp.occupants_uins, this.state.countMemberOnl, nextProps.usersStatus, this.state.usersStatus)
    //     if (isChange) {
    //       console.log('888888888888')
    //       this.setState({ isChange: isChange, usersStatus: usersStatus, countMemberOnl: countMemberOnl }) 
    //     }  
    //   } catch (error) { }
    // }
    if (this.state.group_id && nextProps.netaGroups && nextProps.netaGroups.group_id_change === this.state.group_id) {
      if (nextProps.rxgroup && nextProps.rxgroup.group_id !== this.state.group_id) {
        try {
          let groupTemp = nextProps.netaGroups.groups[nextProps.rxgroup.group_id]
          this.setState({
            group: groupTemp,
            group_id: nextProps.rxgroup.group_id
          })
        } catch (error) {
        }
      } else {
        try {
          let groupTemp = nextProps.netaGroups.groups[Number(this.state.group_id)]
          this.setState({
            group: groupTemp
          })
          if (groupTemp) {
            const { isChange, usersStatus, countMemberOnl } = updateUsersOnline(groupTemp.occupants_uins, this.state.countMemberOnl, this.state.usersStatus)
            if (isChange) this.setState({ isChange: isChange, usersStatus: usersStatus, countMemberOnl: countMemberOnl })
          }
        } catch (error) { }
      }

    }

    if (this.state.group_id && nextProps.netaGroupJoinCall && nextProps.netaGroupJoinCall && nextProps.netaGroupJoinCall['groups'] && nextProps.netaGroupJoinCall['groups'][this.state.group_id] && !checkChangeTabmore) {
      try {
        let groupCallInfo = nextProps.netaGroupJoinCall['groups'][this.state.group_id]
        let timenow = Math.floor(Date.now() / 1000)
        if (groupCallInfo && groupCallInfo['create_at'] && (timenow - groupCallInfo['create_at']) < 3600) {
          this.setState({ isShowBtnGroupCall: false, objGroupCallInfo: nextProps.netaGroupJoinCall['groups'][this.state.group_id] })
        }
      } catch (e) { }
    }

    if (this.state.group_id && nextProps.netaGroupJoinCall && nextProps.netaGroupJoinCall && nextProps.netaGroupJoinCall['groups'] && !nextProps.netaGroupJoinCall['groups'][this.state.group_id] && !this.state.isShowBtnGroupCall) {
      this.setState({ isShowBtnGroupCall: true, objGroupCallInfo: {} })
    }

  }

  componentDidMount() {
    const themeBackGround = global.rxu.json(rxgetLocal('netaThemeBackGround'), '')
    let isBlocked = checkBlock(this.state.group)

    if (isBlocked !== this.state.isBlocked) {
      this.setState({ isBlocked })
    }

    if (themeBackGround === 'darkTheme') {
      changeTheme(themeData.nightTheme)
    } else {
      changeTheme(themeData.defaultTheme)
    }
    const { isChange, usersStatus, countMemberOnl } = updateUsersOnline(this.state.group.occupants_uins, this.state.countMemberOnl, this.state.usersStatus)

    this.updateUserProfile(this.state.group)

    if (rxaget(this.state.group, 'type', 0) === 3) {
      this.checkUserStatus(this.state.group)
    }
    if (isChange) {
      this.setState({ isChange: isChange, usersStatus: usersStatus, countMemberOnl: countMemberOnl, isShowBtnGroupCall: true })
    }
    if (window && window.ipcRenderer) {
      window.ipcRenderer.on('open_rating_call', (event, args) => {
        this.stoppedCallObj = { ...args }
        this.openCallRating(true)
      })
    }
  }

  componentDidUpdate(nextprop) {
    const new_group = rxaget(nextprop, 'rxgroup.group', {})
    if (new_group.group_id !== '' && new_group.group_id !== this.state.group_id) {

      if (new_group && new_group.isDraft) {
        new_group.group_fullname = (new_group.fullnamegroup) ? new_group.fullnamegroup : new_group.group_fullname || ''
      }
      if (rxaget(new_group, 'type', 0) === 3) {
        this.checkUserStatus(new_group)
      }
      this.updateUserProfile(new_group)

      this.setState({ group: new_group, group_id: new_group.group_id, isShowBtnGroupCall: true })
    }
  }

  async updateUserProfile(ogroup) {
    let partnerUSer = this.state.partnerUSer

    if (ogroup.type === 3 || ogroup.type === 5) {
      let arrUins = rxaget(ogroup, 'occupants_uins', []).filter(u => u.toString() !== this.userid.toString())
      if (arrUins && arrUins.constructor === Array && arrUins.length > 0) {
        let partnerId = arrUins[0]
        let userInDB = await chatDB.users.get({ uid: Number(partnerId) })
        if (userInDB) {
          partnerUSer.full_name = (userInDB.full_name) ? userInDB.full_name : (userInDB.phone) ? userInDB.phone : ''
          partnerUSer.profile_url = (userInDB.profile_url) ? userInDB.profile_url : ''

          this.setState(partnerUSer)
        }
      }
    }
  }

  onClickTabMore() {
    const tabmore = this.state.tabmore
    this.props.changeStatusTabmore(!tabmore)
  }

  onClickStartCall(typeCall) {
    console.log({
      typeCall,
      group_id: rxaget(this.state, 'group.group_id', ''),
      type: rxaget(this.state, 'group.type', 0),
      occupants_uins: rxaget(this.state, 'group.occupants_uins', [])
    })
    // this.props.updateRecentContactGroups(this.state.group.partner_id,Date.now())
    this.props.clickCall(typeCall, {
      group_id: rxaget(this.state, 'group.group_id', ''),
      type: rxaget(this.state, 'group.type', 0),
      occupants_uins: rxaget(this.state, 'group.occupants_uins', [])
    })
  }

  onClickStartGroupCall(typeCall) {

    // this.props.updateRecentContactGroups(this.state.group.partner_id,Date.now())
    this.props.clickGroupCall(typeCall, {
      group_id: rxaget(this.state, 'group.group_id', ''),
      type: rxaget(this.state, 'group.type', 0),
      occupants_uins: rxaget(this.state, 'group.occupants_uins', [])
    })
  }

  onClickJoinGroupCall() {
    let data = this.state.objGroupCallInfo
    if (data.group_id && data.message_id) {
      this.props.clickGroupCall('groupcall', {
        group_id: rxaget(data, 'group_id', ''),
        message_id: rxaget(data, 'message_id', ''),
        type: rxaget(data, 'type', 0),
        occupants_uins: rxaget(data, 'group.occupants_uins', [])
      })
    } //else {
    //alert(translate('You were on a group call'))
    //}
  }

  helpTimeText(timestamp) {
    const a = new Date(timestamp * 1000)
    const months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
    const month = months[a.getMonth()]; const date = a.getDate(); const hour = a.getHours(); const min = a.getMinutes()
    const time = `${date}/${month} ${hour}:${min}`
    return time
  }

  loadImgStatic(obj, name, url = global.rxu.config.cdn_endpoint) {
    if (obj.sender_avatar) {
      return global.rxu.config.get_static + obj.sender_avatar
    } else if (obj.avatar_url) {
      return global.rxu.config.get_static + obj.avatar_url
    } else if (obj.type === 3 && !obj.avatar_url) {
      const users = this.users
      if (obj && obj.occupants_uins && obj.occupants_uins.constructor === Array && obj.occupants_uins.length === 2 && obj.occupants_uins.indexOf(this.userid.toString()) !== -1) {
        const arruserid = obj.occupants_uins.filter(o => o !== this.userid.toString())
        if (arruserid && arruserid.constructor === Array && arruserid[0] && users[arruserid[0]] && users[arruserid[0]].profile_url) {
          return url + users[arruserid[0]].profile_url
        }
      } else {
        return './images/default/static/avadefault.svg'
      }
    } else {
      return './images/default/static/avadefault.svg'
    }
  }

  uniqArray(a) {
    return Array.from(new Set(a));
  }

  getNumMemberOnl(group) {
    let userid = this.userid
    let countMemberOnl = getNumMemberOnl(group, userid)
    return countMemberOnl
  }

  getNameUser(user) {
    return (user && user.name_display) ? user.name_display : (user.full_name) ? user.full_name : (user.phone) ? user.phone : translate('Stranger')
  }

  checkUserStatus(group) {
    let partner_id = group.partner_id
    apiGetUserStatus(this.token, partner_id, (json) => {
      if (json && json.status_message) {
        let userStatus = json
        let updateObj = {
          userStatus: userStatus
        }
        if (this.getUserStatus_txt(group.userStatus) !== this.getUserStatus_txt(userStatus)) {
          group.userStatus = { ...userStatus }
          chatDB.groups.update(group.group_id.toString(), updateObj).then(o => { }).catch(e => { })
        }

      } else {
        group.userStatus = { status_message: '', status_message_en: '' }
        chatDB.groups.update(group.group_id.toString(), { status_message: '', status_message_en: '' }).then(o => { }).catch(e => { })
      }
      this.setState({ group: group })
    })
  }

  getUserStatus_txt(userStatus) {
    let user_status_txt = ''
    if (userStatus && userStatus.status_message && userStatus.status_message_en) {
      user_status_txt = this.props.langValue === 'en' ? userStatus.status_message_en : userStatus.status_message
    }
    return user_status_txt
  }

  checkUpdateUserStatus(group, newGroup) {
    let flagCheckUpdate = false
    if (group.group_id === newGroup.group_id) {
      if (group.userStatus && !newGroup.userStatus) {
        //have another component update recent group
        return false
      }
      if (this.getUserStatus_txt(rxaget(group, 'userStatus', {})) !== this.getUserStatus_txt(rxaget(newGroup, 'userStatus', {}))) {
        flagCheckUpdate = true
      }

    }
    return flagCheckUpdate
  }

  // Đánh giá cuộc gọi
  openCallRating(isOpen) {
    this.setState({ open_call_rating: isOpen })
  }

  render() {
    return this.renderComponent()
  }
}

const mapStateToProps = (state, ownProps) => ({
  themeValue: state.themeValue,
  langValue: state.langValue,
  rxgroup: state.rxgroup,
  user: state.user,
  netaauth: state.netaauth,
  netaCallHistory: state.netaCallHistory,
  netaGroups: state.netaGroups,
  tabmore: state.tabmore,
  usersStatus: state.usersStatus,
  netaGroupJoinCall: state.netaGroupJoinCall
})

const mapDispatchToProps = {
  netaCallHistoryUpdate,
  changeStatusTabmore,
  updateRecentContactGroups,
  clickCall,
  clickGroupCall,
  rxnavToggle,
  chooseGroupAction
}

const ComponentWrapped = connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderComponent_)

export default ComponentWrapped